import { el, mount, unmount, setChildren } from 'redom';

import { displayElementAroundAnchor } from 'utilities/element-position';

import './index.scss';

class PositionedTooltip {

  constructor() {
    this.el = el('.positioned-tooltip', {
      onmouseenter: this.cancelHide.bind(this),
      onmouseleave: this.hide.bind(this)
    });
    this.mounted = false;
    this.hideTimeout = null;
    this.tooltipHovered = false;
  }

  show(anchorElement, content, startSide) {

    if (typeof content === 'string') {
      this.el.textContent = content;
    } else {
      setChildren(this.el, [content]);
    }

    if (this.mounted === false) {
      mount(document.body, this.el);
      this.mounted = true;
    }

    displayElementAroundAnchor(
      this.el,
      anchorElement,
      document.body,
      5,
      5,
      startSide || 'right',
      true
    );

  }

  cancelHide() {

    this.tooltipHovered = true;

    if (this.hideTimeout !== null) {
      clearTimeout(this.hideTimeout);
      this.hideTimeout = null;
    }

  }

  hideWithDelay() {

    this.hideTimeout = setTimeout(function runHide() {

      if (this.tooltipHovered === false) {
        this.hide();
      }

    }.bind(this), 150);

  }

  hide() {

    if (this.hideTimeout !== null) {
      clearTimeout(this.hideTimeout);
      this.hideTimeout = null;
    }

    this.tooltipHovered = false;

    if (this.mounted === true) {
      unmount(document.body, this.el);
      this.mounted = false;
    }

  }

}

export default PositionedTooltip;
